import { User } from '../../domain/user';
import { mapper } from '../../tools/mapping/mapper';
import { UserEntity } from '../entity';
import type { AppDB } from '../db';

export class UserRepository {
    constructor(private readonly database: AppDB) {}


    async getUserById(id: number) {
        return await this.database.users.where('Id').equals(id).first(async ue => {
            const user = mapper.map(ue, UserEntity, User);
            return user;
        });
    }

    async attachUser(user: User, intId: number, forSampler: boolean) {
        let userId: number;
        const ue = mapper.map(user, User, UserEntity);

        userId = await this.database.users.add(ue);
        if (forSampler) {
            await this.database.interventions.update(intId, {
                SamplerId: userId
            });
        } else {
            await this.database.interventions.update(intId, {
                ContactId: userId
            });
        }
        return userId;
    }
}
